import React from 'react';

export default class FileTypeTeams extends React.Component {
    public render() {
        return <svg enableBackground="new 0 0 128 128" id="teams"  version="1.1" viewBox="0 0 128 128" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <circle fill="#4F59CA" cx="111.1" cy="30.2" r="13" />
            <path fill="#4F59CA" d="M108.3,104.8h-2c-10.7,0-19.3-8.7-19.3-19.3V54.9c0-3.1,2.5-5.5,5.5-5.5h29.6c3.1,0,5.5,2.5,5.5,5.5v30.5  C127.7,96.1,119,104.8,108.3,104.8z" />
            <circle fill="#7B82EA" cx="70.3" cy="24.2" r="18.7" />
            <path fill="#7B82EA" d="M70.4,122.1h-3.2c-16.8,0-30.5-13.7-30.5-30.5V54.1c0-2.5,2.1-4.6,4.6-4.6h55c2.5,0,4.6,2.1,4.6,4.6v37.5  C100.9,108.4,87.3,122.1,70.4,122.1z" />
            <path fill="#4C53BB" d="M59.5,97.2h-53c-3.5,0-6.4-2.9-6.4-6.4V38.6c0-3.5,2.9-6.4,6.4-6.4h53c3.5,0,6.4,2.9,6.4,6.4v52.2  C65.9,94.3,63.1,97.2,59.5,97.2z" />
            <g>
                <path fill="#FFFFFF" d="M29.4,52.7H19v-5.5h27.5v5.5H36.1V83h-6.6V52.7z" />
            </g>
            <path opacity="0.2" d="M66,49.5v41.2c0,3.5-2.9,6.4-6.4,6.4H37.2l1.5,5.7H65c3.5,0,6.4-2.9,6.4-6.4V49.5L66,49.5z" />
        </svg>;
    }
}